import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { getCaseSites } from './sites';
import { TASK_TYPE } from 'saas/constants';
import { serializeTools } from './tools';
import { serializeDiagnosticValues } from './serialize';
import {
  FETCH_DIAGNOSTIC,
  FETCH_DIAGNOSTIC_SUCCESS,
  SERIALIZE_DIAGNOSTIC,
} from '../actions/diagnostic';
import { ADD_TOOL, UPDATE_TOOL, DELETE_TOOL } from '../actions/tools';

const updateInSite = (state, site) => thunk => {
  return state.update(site, Map(), thunk);
};

const content = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_DIAGNOSTIC_SUCCESS:
      return updateInSite(
        state,
        action.site
      )(d => d.set(action.diagnostic, action.content));
    default:
      return state;
  }
};

const values = (state = Map(), action) => {
  switch (action.type) {
    case SERIALIZE_DIAGNOSTIC:
      return updateInSite(
        state,
        action.site
      )(d => d.set(action.diagnostic, action.values));
    default:
      return state;
  }
};

const isFetching = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_DIAGNOSTIC:
      return updateInSite(
        state,
        action.site
      )(d => d.set(action.diagnostic, true));
    case FETCH_DIAGNOSTIC_SUCCESS:
      return updateInSite(state, action.site)(d => d.delete(action.diagnostic));
    default:
      return state;
  }
};

const mustSerialize = (state = Map(), action) => {
  switch (action.type) {
    case ADD_TOOL:
    case UPDATE_TOOL:
    case DELETE_TOOL:
      return updateInSite(
        state,
        action.site
      )(ns => ns.set(action.diagnostic, true));
    default:
      return state;
  }
};

const diagnostic = combineReducers({
  content,
  values,
  isFetching,
  mustSerialize,
});

export default diagnostic;

export const getContent = (state, site) =>
  state.siteCase.diagnostic.content.get(site, Map());
export const getValues = (state, site) =>
  state.siteCase.diagnostic.values.get(site, Map());
export const getIsFetching = (state, site) =>
  state.siteCase.diagnostic.isFetching.get(site, Map());
export const getMustSerialize = (state, site) =>
  state.siteCase.diagnostic.mustSerialize.get(site, Map());

const serializeDiagnostic = (state, site) => {
  const values = getValues(state, site);

  const serializeType = type => {
    const data = values.get(type);
    const tools = serializeTools(state, site, type);

    return {
      data: serializeDiagnosticValues(type, data),
      ...tools,
    };
  };

  const rat = serializeType(TASK_TYPE.RAT);
  const insect = serializeType(TASK_TYPE.INSECT);
  const disinfection = serializeType(TASK_TYPE.DISINFECTION);
  const other_pests = serializeType(TASK_TYPE.OTHER_PESTS);
  const annex_1 = serializeType(TASK_TYPE.ANNEX1);
  const annex_2 = serializeType(TASK_TYPE.ANNEX2);

  return {
    id: site,
    rat,
    insect,
    disinfection,
    other_pests,
    annex_1,
    annex_2,
  };
};

export const getSerializedDiagnostics = state => {
  const sites = getCaseSites(state);
  const serialized = sites.map(s =>
    serializeDiagnostic(state, s.id.toString())
  );

  // Group them by id
  const byId = serialized.reduce((map, item) => map.set(item.id, item), Map());
  return byId.toObject();
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/diagnostic.js